import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';
import useHasHydrated from '@/hooks/use-has-hydrated';

import ProfileCard from './ProfileCard';
import ProfileLoader from './ProfileLoader';

function TripletProfileCard() {
  const hasHydrated = useHasHydrated();

  return (
    <Wrapper>
      {hasHydrated
        ? [
            <CardWrapper key="card-1">
              <ProfileCard
                avatarBackdropIndex={0}
                avatarIndex={5}
                name="Anthony Harris"
                handle="theboxmodel"
                city="San Francisco"
                country="US"
                job="Staff UI/UX Designer"
              />
            </CardWrapper>,
            <CardWrapper key="card-2">
              <ProfileCard
                avatarBackdropIndex={2}
                avatarIndex={12}
                name="Dr. Kai Bechstein"
                handle="pianofingers"
                city="Berlin"
                country="DE"
                job="Physician"
              />
            </CardWrapper>,
            <CardWrapper key="card-3">
              <ProfileCard
                avatarBackdropIndex={4}
                avatarIndex={13}
                name="Faajal Singh"
                handle="faajal31"
                city="Vancouver"
                country="CA"
                job="Principal Engineer"
              />
            </CardWrapper>,
          ]
        : [
            <ProfileLoader key="loader-1" />,
            <ProfileLoader key="loader-2" />,
            <ProfileLoader key="loader-3" />,
          ]}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  margin: 0 -32px 32px;
  padding: 16px 16px 16px;
  overflow: auto;

  @media ${BREAKPOINTS.mdAndSmaller} {
    margin-inline: -16px;
  }
`;

const CardWrapper = styled.div`
  flex: 1;
  min-width: 14rem;
  container-type: inline-size;
`;

export default TripletProfileCard;
